/* Arria grup yorumları: görünür olunca JSON'u yükler, temanın kaydırıcısında kartları kurar,
   karta tıklanınca yorumu ve görsellerini büyük açılır pencerede gösterir. */
if (!customElements.get('arria-group-reviews')) {
  // Fotoğraflar tema dosyası (arria-gr-*.jpg) ya da eski Etsy adresi olabilir
  let assetBase = '';
  const src = (url) => (/^https?:/.test(url) ? url : assetBase + url);
  const thumb = (url) => src(url).replace('_fullxfull.', '_640x640.');
  const monthYear = (d) => {
    const [y, m] = d.split('-').map(Number);
    return new Date(y, m - 1).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  };
  const el = (tag, cls, text) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  };

  class ArriaGroupReviews extends HTMLElement {
    connectedCallback() {
      window.initLazyScript(this, () => this.load(), 400);
    }

    async load() {
      try {
        assetBase = this.dataset.assetBase || '';
        const res = await fetch(this.dataset.src);
        const data = (await res.json())[this.dataset.group];
        if (!data || !data.reviews.length) throw new Error('no data');
        this.data = data;
        this.reviews = data.reviews;
        this.renderHeader();
        this.renderCarousel();
        this.setupDialog();
        this.removeAttribute('data-loading');
      } catch (e) {
        this.hidden = true; // veri yoksa bölüm gizli kalır
      }
    }

    renderHeader() {
      const { label, count, average, distribution } = this.data;
      this.querySelector('.arria-gr__title').textContent = this.dataset.heading.replace('{group}', label);
      this.querySelector('.arria-gr__note span').textContent = this.dataset.note.replace('{group}', label);
      this.querySelector('.arria-gr__avg').textContent = average.toFixed(1);
      const stars = this.querySelector('.arria-gr__avg-stars');
      stars.style.setProperty('--rating', average);
      stars.style.setProperty('--rating-max', 5);
      this.querySelector('.arria-gr__count').textContent =
        `Based on ${count.toLocaleString('en-US')} reviews`;

      const bars = this.querySelector('.arria-gr__bars');
      Object.entries(distribution)
        .sort((a, b) => b[0] - a[0])
        .forEach(([star, n]) => {
          const pct = count ? Math.round((n / count) * 100) : 0;
          const li = el('li', 'arria-gr__bar');
          li.append(el('span', 'arria-gr__bar-label text-sm', `${star} ★`));
          const track = el('span', 'arria-gr__bar-track');
          track.setAttribute('aria-hidden', 'true');
          const fill = el('span', 'arria-gr__bar-fill');
          fill.style.width = `${pct}%`;
          track.append(fill);
          li.append(track, el('span', 'arria-gr__bar-pct text-sm', `${pct}%`));
          li.setAttribute('aria-label', `${star} stars: ${pct}%`);
          bars.append(li);
        });
    }

    renderCarousel() {
      const shell = this.querySelector('.arria-gr__carousel-tpl').content.cloneNode(true);
      const grid = shell.querySelector('.slider__grid');
      this.reviews.forEach((r, i) => grid.append(this.card(r, i)));
      // Kaydırıcı, slaytlar yerindeyken DOM'a girmeli (carousel-slider kurulumda slaytları sayar).
      this.querySelector('.arria-gr__slot').replaceWith(shell);
    }

    card(r, index) {
      const li = el('li', 'slider__item');
      const card = el('button', 'arria-gr__card');
      card.type = 'button';
      card.dataset.index = index;
      card.setAttribute('aria-label', `Open review: ${r.r} out of 5 stars`);

      if (r.i.length) {
        const media = el('span', 'arria-gr__media');
        const img = el('img', 'arria-gr__img');
        img.src = thumb(r.i[0]);
        img.alt = '';
        img.loading = 'lazy';
        img.draggable = false;
        img.width = 640;
        img.height = 640;
        img.addEventListener('error', () => media.remove());
        media.append(img);
        if (r.i.length > 1) media.append(el('span', 'arria-gr__more-photos text-sm', `+${r.i.length - 1}`));
        card.append(media);
      }

      const body = el('span', 'arria-gr__card-body');
      const stars = el('span', 'rating__stars arria-gr__stars', '★★★★★');
      stars.style.setProperty('--rating', r.r);
      stars.style.setProperty('--rating-max', 5);
      stars.setAttribute('aria-hidden', 'true');
      body.append(
        stars,
        el('span', 'arria-gr__text', r.b),
        el('span', 'arria-gr__meta text-sm', `Marketplace buyer · ${monthYear(r.d)}`),
        el('span', 'arria-gr__product text-sm', r.p)
      );
      card.append(body);
      card.addEventListener('click', () => this.open(index));
      li.append(card);
      return li;
    }

    setupDialog() {
      this.dialog = this.querySelector('.arria-gr__dialog');
      this.dialogImg = this.dialog.querySelector('.arria-gr__dialog-img');
      this.thumbs = this.dialog.querySelector('.arria-gr__thumbs');
      this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.querySelectorAll('[data-step]').forEach((btn) => {
        btn.addEventListener('click', () => this.show(this.current + Number(btn.dataset.step)));
      });
      // Pencere dışına (arka plana) tıklayınca kapat
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.show(this.current + 1);
        if (e.key === 'ArrowLeft') this.show(this.current - 1);
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('arria-gr-lock');
        this.lastCard?.focus();
      });
    }

    open(index) {
      this.lastCard = this.querySelector(`.arria-gr__card[data-index="${index}"]`);
      this.show(index);
      document.documentElement.classList.add('arria-gr-lock');
      this.dialog.showModal();
    }

    show(index) {
      const total = this.reviews.length;
      this.current = (index + total) % total;
      const r = this.reviews[this.current];
      const d = this.dialog;

      d.classList.toggle('arria-gr__dialog--no-media', !r.i.length);
      this.thumbs.replaceChildren();
      if (r.i.length) {
        this.setPhoto(r.i[0]);
        if (r.i.length > 1) {
          r.i.forEach((url, i) => {
            const b = el('button', `arria-gr__thumb${i === 0 ? ' is-active' : ''}`);
            b.type = 'button';
            b.setAttribute('aria-label', `Photo ${i + 1} of ${r.i.length}`);
            const t = el('img');
            t.src = thumb(url);
            t.alt = '';
            t.draggable = false;
            b.append(t);
            b.addEventListener('click', () => {
              this.thumbs.querySelectorAll('.is-active').forEach((x) => x.classList.remove('is-active'));
              b.classList.add('is-active');
              this.setPhoto(url);
            });
            this.thumbs.append(b);
          });
        }
      }

      const stars = d.querySelector('.arria-gr__dialog-stars');
      stars.style.setProperty('--rating', r.r);
      stars.style.setProperty('--rating-max', 5);
      d.querySelector('.arria-gr__dialog-text').textContent = r.b;
      d.querySelector('.arria-gr__dialog-meta').textContent = `${r.r} out of 5 · Marketplace buyer · ${monthYear(r.d)}`;
      d.querySelector('.arria-gr__dialog-product').textContent = r.p;
      d.querySelector('.arria-gr__dialog-pos').textContent = `${this.current + 1} / ${total}`;
    }

    setPhoto(url) {
      this.dialogImg.src = src(url);
      this.dialogImg.alt = 'Photo shared by the buyer';
    }
  }

  customElements.define('arria-group-reviews', ArriaGroupReviews);
}
